import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useDinosaurContext } from '../contexts/DinosaurContext';


const dinosaurAdventure = keyframes`
  0% { 
    transform: translate(100vw, 0px) scale(1) rotate(0deg);
    opacity: 1;
  }
  10% { 
    transform: translate(85vw, -50px) scale(1.5) rotate(-5deg);
    opacity: 1;
  }
  20% { 
    transform: translate(70vw, -100px) scale(2) rotate(5deg);
    opacity: 1;
  }
  30% { 
    transform: translate(55vw, -150px) scale(2.5) rotate(-10deg);
    opacity: 1;
  }
  40% { 
    transform: translate(40vw, -200px) scale(3) rotate(8deg);
    opacity: 1;
  }
  45% { 
    transform: translate(30vw, -250px) scale(3.5) rotate(180deg);
    opacity: 1;
  }
  50% { 
    transform: translate(20vw, -300px) scale(4) rotate(360deg);
    opacity: 1;
  }
  55% { 
    transform: translate(10vw, -250px) scale(3.5) rotate(540deg);
    opacity: 1;
  }
  60% { 
    transform: translate(0vw, -200px) scale(3) rotate(10deg);
    opacity: 1;
  }
  70% { 
    transform: translate(-10vw, -150px) scale(2.5) rotate(-8deg);
    opacity: 1;
  }
  80% { 
    transform: translate(-20vw, -100px) scale(2) rotate(5deg);
    opacity: 1;
  }
  90% { 
    transform: translate(-30vw, -50px) scale(1.5) rotate(-3deg);
    opacity: 1;
  }
  100% { 
    transform: translate(-40vw, 0px) scale(1) rotate(0deg);
    opacity: 0;
  }
`;

const explosion = keyframes`
  0% { 
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  50% { 
    transform: scale(1.5) rotate(180deg);
    opacity: 0.8;
  }
  100% { 
    transform: scale(2) rotate(360deg);
    opacity: 0;
  }
`;

const particleFloat = keyframes`
  0% { transform: translateY(0) rotate(0deg); opacity: 1; }
  100% { transform: translateY(-20px) rotate(360deg); opacity: 0; }
`;


const AdventureDinosaur = styled.div`
  position: fixed;
  font-size: 80px;
  z-index: 1000;
  pointer-events: none;
  filter: drop-shadow(8px 8px 16px rgba(0, 0, 0, 0.8));
  animation: ${dinosaurAdventure} 4s ease-in-out forwards;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
`;

const Explosion = styled.div`
  position: fixed;
  font-size: 40px;
  z-index: 1001;
  pointer-events: none;
  animation: ${explosion} 1s ease-out forwards;
`;

const Sparkle = styled.span`
  font-size: 20px;
  animation: ${particleFloat} 2s ease-in-out infinite;
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const DinosaurEasterEgg = () => {
  const { showAdventureDino, showSparkles, explosions } = useDinosaurContext();

  const getRandomSparkle = () => {
    const sparkles = ['✨', '💫', '⭐', '🌟', '💥', '🔥', '⚡', '🎉'];
    return sparkles[Math.floor(Math.random() * sparkles.length)];
  };

  const getRandomExplosion = () => {
    const explosions = ['💥', '💣', '🔥', '⚡', '💫', '✨', '🌟', '⭐'];
    return explosions[Math.floor(Math.random() * explosions.length)];
  };

  return (
    <>
      {showAdventureDino && (
        <AdventureDinosaur>
          🦖
        </AdventureDinosaur>
      )}

      {explosions.map((explosion) => (
        <Explosion
          key={explosion.id}
          style={{
            left: explosion.x,
            top: explosion.y,
          }}
        >
          {getRandomExplosion()}
        </Explosion>
      ))}

      {showSparkles && (
        <>
          <Sparkle style={{ left: '10%', animationDelay: '0s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '20%', animationDelay: '0.2s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '30%', animationDelay: '0.4s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '40%', animationDelay: '0.6s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '50%', animationDelay: '0.8s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '60%', animationDelay: '1s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '70%', animationDelay: '1.2s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '80%', animationDelay: '1.4s' }}>{getRandomSparkle()}</Sparkle>
          <Sparkle style={{ left: '90%', animationDelay: '1.6s' }}>{getRandomSparkle()}</Sparkle>
        </>
      )}

    </>
  );
};

export default DinosaurEasterEgg;
